<div class="row text-center animated fadeIn m-4">
    <div class="col">
        <img src="../../../../assets/images/load_2.gif" alt="...">
        <!-- <i class="fa fa-spinner fa-spin fa-4x"></i> -->
    </div>
</div>